export const EXPLORATION_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    STOPPED: 'STOPPED',
    FINISHED: 'FINISHED',
    EXHAUSTED: 'EXHAUSTED',
    CAMPAIGN_TERMINATED: 'CAMPAIGN_TERMINATED',
};
